export default {
  list: state => state.list,
  errors: state => state.errors
};
